import InfoFlyUpModal from "./index";

export default function InfoFlyUpModalExamples() {
  return (
    <InfoFlyUpModal
      cardProps={{
        title: "Card title",
        description: "Card description",
      }}
      modalProps={{
        title: "Modal title",
        description: "Modal description",
        importanceTitle: "Importance title",
        unorderedList: ["Item 1", "Item 2", "Item 3"] as string[],
        textList: ["Item 1", "Item 2", "Item 3"] as string[],
      }}
    />
  );
}
